import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageCycleDurationBackground = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 223.218,
	height: 206.148,
	viewBox: "0 0 223.218 206.148",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2152",
				x: 68.93,
				y: 12.204,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2153",
				x: 118.43,
				y: 62.205,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-2"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-2"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2153-2",
				x: 116.559,
				y: 148.853,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-3"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-3"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "Path_2152-2",
				x: 68.93,
				y: 101.5,
				width: 34.242,
				height: 57.296,
				filterUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 3,
						result: "blur-4"
					}),
					/* @__PURE__ */ _jsx("feFlood", { floodOpacity: .161 }),
					/* @__PURE__ */ _jsx("feComposite", {
						operator: "in",
						in2: "blur-4"
					}),
					/* @__PURE__ */ _jsx("feComposite", { in: "SourceGraphic" })
				]
			})
		] }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2666",
			"data-name": "Group 2666",
			transform: "translate(-527.366 -991)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Rectangle_589",
					"data-name": "Rectangle 589",
					transform: "translate(543 991)",
					fill: "#58595b",
					stroke: "#707070",
					strokeWidth: 1,
					children: [/* @__PURE__ */ _jsx("rect", {
						width: 45,
						height: 15,
						rx: 7.5,
						stroke: "none"
					}), /* @__PURE__ */ _jsx("rect", {
						x: .5,
						y: .5,
						width: 44,
						height: 14,
						rx: 7,
						fill: "none"
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Rectangle_590",
					"data-name": "Rectangle 590",
					transform: "translate(671 991)",
					fill: "#58595b",
					stroke: "#707070",
					strokeWidth: 1,
					children: [/* @__PURE__ */ _jsx("rect", {
						width: 45,
						height: 15,
						rx: 7.5,
						stroke: "none"
					}), /* @__PURE__ */ _jsx("rect", {
						x: .5,
						y: .5,
						width: 44,
						height: 14,
						rx: 7,
						fill: "none"
					})]
				}),
				/* @__PURE__ */ _jsx("text", {
					id: "Left",
					transform: "translate(556 1001)",
					fill: "#fff",
					fontSize: 9,
					fontFamily: "Montserrat-SemiBold, Montserrat",
					fontWeight: 600,
					children: /* @__PURE__ */ _jsx("tspan", {
						x: 0,
						y: 0,
						children: "\n            Left\n          "
					})
				}),
				/* @__PURE__ */ _jsx("text", {
					id: "Right",
					transform: "translate(683 1001)",
					fill: "#fff",
					fontSize: 9,
					fontFamily: "Montserrat-SemiBold, Montserrat",
					fontWeight: 600,
					children: /* @__PURE__ */ _jsx("tspan", {
						x: 0,
						y: 0,
						children: "\n            Right\n          "
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_250",
			"data-name": "Group 250",
			transform: "translate(77.93 57.5) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 57.5, -77.93)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2152-3",
					"data-name": "Path 2152",
					d: "M10.712,39.259c7.761-.909,3.522-11.949,3.522-17.686,0-3.609,2.008-6.122,2.008-11.066C16.242,5.787,14.064.344,9.6.021,3.437-.426,0,6.387,0,13.05c0,4.026,2.731,10.732,3.346,13.475C4.21,30.381,4.669,39.967,10.712,39.259Z",
					transform: "translate(77.93 18.2)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_243",
				"data-name": "Group 243",
				transform: "translate(8.01 7.765) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_190",
						"data-name": "Path 190",
						d: "M.155,3.014A3.782,3.782,0,0,0,1.748,1.623,7.618,7.618,0,0,0,2.459,0,2.516,2.516,0,0,0,.067,3.09.336.336,0,0,1,.155,3.014Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_191",
						"data-name": "Path 191",
						d: "M3.326.8A2.567,2.567,0,0,1,1.272,2.067,3.035,3.035,0,0,1,0,1.84a2.512,2.512,0,0,0,1.958.936A2.518,2.518,0,0,0,4.475.259,2.536,2.536,0,0,0,4.461,0C4.374,0,3.9.022,3.326.8Z",
						transform: "translate(0.56 2.258)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_192",
						"data-name": "Path 192",
						d: "M1.466,2.205C2.954,2.16,3.358,1,3.9.582a1.522,1.522,0,0,1,.9-.36C4.786.148,4.771.075,4.753,0a1.976,1.976,0,0,0-1.2.3,7.02,7.02,0,0,1-1.62,1.185A3.283,3.283,0,0,1,0,1.631a2.517,2.517,0,0,0,.157.307A3.147,3.147,0,0,0,1.466,2.205Z",
						transform: "translate(0.2 1.87)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_193",
						"data-name": "Path 193",
						d: "M0,3.13c.13.26,1.027-.024,1.413-.263.545-.339,1.107-1.084,1.752-1.26a2.748,2.748,0,0,1,.775-.1A2.518,2.518,0,0,0,1.8,0a7.848,7.848,0,0,1-.591,1.6C.694,2.676-.064,2.994,0,3.13Z",
						transform: "translate(0.883 0.005)",
						fill: "#fff"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_251",
			"data-name": "Group 251",
			transform: "translate(127.43 107.5) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 107.5, -127.43)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2153-3",
					"data-name": "Path 2153",
					d: "M5.529,39.259c-7.761-.909-3.522-11.949-3.522-17.686C2.008,17.964,0,15.45,0,10.507,0,5.787,2.178.344,6.64.021c6.164-.447,9.6,6.366,9.6,13.029,0,4.026-2.732,10.732-3.347,13.475C12.031,30.381,11.572,39.967,5.529,39.259Z",
					transform: "translate(127.43 68.2)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_244",
				"data-name": "Group 244",
				transform: "translate(8.01 3.505) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_190-2",
						"data-name": "Path 190",
						d: "M.155,3.014A3.782,3.782,0,0,0,1.748,1.623,7.618,7.618,0,0,0,2.459,0,2.516,2.516,0,0,0,.067,3.09.336.336,0,0,1,.155,3.014Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_191-2",
						"data-name": "Path 191",
						d: "M3.326.8A2.567,2.567,0,0,1,1.272,2.067,3.035,3.035,0,0,1,0,1.84a2.512,2.512,0,0,0,1.958.936A2.518,2.518,0,0,0,4.475.259,2.536,2.536,0,0,0,4.461,0C4.374,0,3.9.022,3.326.8Z",
						transform: "translate(0.56 2.258)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_192-2",
						"data-name": "Path 192",
						d: "M1.466,2.205C2.954,2.16,3.358,1,3.9.582a1.522,1.522,0,0,1,.9-.36C4.786.148,4.771.075,4.753,0a1.976,1.976,0,0,0-1.2.3,7.02,7.02,0,0,1-1.62,1.185A3.283,3.283,0,0,1,0,1.631a2.517,2.517,0,0,0,.157.307A3.147,3.147,0,0,0,1.466,2.205Z",
						transform: "translate(0.2 1.87)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_193-2",
						"data-name": "Path 193",
						d: "M0,3.13c.13.26,1.027-.024,1.413-.263.545-.339,1.107-1.084,1.752-1.26a2.748,2.748,0,0,1,.775-.1A2.518,2.518,0,0,0,1.8,0a7.848,7.848,0,0,1-.591,1.6C.694,2.676-.064,2.994,0,3.13Z",
						transform: "translate(0.883 0.005)",
						fill: "#fff"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2642",
			"data-name": "Group 2642",
			transform: "translate(125.559 194.148) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 194.15, -125.56)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2153-4",
					"data-name": "Path 2153",
					d: "M5.529,39.259c-7.761-.909-3.522-11.949-3.522-17.686C2.008,17.964,0,15.45,0,10.507,0,5.787,2.178.344,6.64.021c6.164-.447,9.6,6.366,9.6,13.029,0,4.026-2.732,10.732-3.347,13.475C12.031,30.381,11.572,39.967,5.529,39.259Z",
					transform: "translate(125.56 154.85)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_244-2",
				"data-name": "Group 244",
				transform: "translate(8.01 3.505) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_190-3",
						"data-name": "Path 190",
						d: "M.155,3.014A3.782,3.782,0,0,0,1.748,1.623,7.618,7.618,0,0,0,2.459,0,2.516,2.516,0,0,0,.067,3.09.336.336,0,0,1,.155,3.014Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_191-3",
						"data-name": "Path 191",
						d: "M3.326.8A2.567,2.567,0,0,1,1.272,2.067,3.035,3.035,0,0,1,0,1.84a2.512,2.512,0,0,0,1.958.936A2.518,2.518,0,0,0,4.475.259,2.536,2.536,0,0,0,4.461,0C4.374,0,3.9.022,3.326.8Z",
						transform: "translate(0.56 2.258)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_192-3",
						"data-name": "Path 192",
						d: "M1.466,2.205C2.954,2.16,3.358,1,3.9.582a1.522,1.522,0,0,1,.9-.36C4.786.148,4.771.075,4.753,0a1.976,1.976,0,0,0-1.2.3,7.02,7.02,0,0,1-1.62,1.185A3.283,3.283,0,0,1,0,1.631a2.517,2.517,0,0,0,.157.307A3.147,3.147,0,0,0,1.466,2.205Z",
						transform: "translate(0.2 1.87)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_193-3",
						"data-name": "Path 193",
						d: "M0,3.13c.13.26,1.027-.024,1.413-.263.545-.339,1.107-1.084,1.752-1.26a2.748,2.748,0,0,1,.775-.1A2.518,2.518,0,0,0,1.8,0a7.848,7.848,0,0,1-.591,1.6C.694,2.676-.064,2.994,0,3.13Z",
						transform: "translate(0.883 0.005)",
						fill: "#fff"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("line", {
			id: "Line_35",
			"data-name": "Line 35",
			y2: 134,
			transform: "translate(110.801 40.5)",
			fill: "none",
			stroke: "#707070",
			strokeLinecap: "round",
			strokeWidth: 1,
			strokeDasharray: "1 2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2641",
			"data-name": "Group 2641",
			transform: "translate(77.93 146.796) rotate(-90)",
			children: [/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0, 1, -1, 0, 146.8, -77.93)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2152-4",
					"data-name": "Path 2152",
					d: "M10.712,39.259c7.761-.909,3.522-11.949,3.522-17.686,0-3.609,2.008-6.122,2.008-11.066C16.242,5.787,14.064.344,9.6.021,3.437-.426,0,6.387,0,13.05c0,4.026,2.731,10.732,3.346,13.475C4.21,30.381,4.669,39.967,10.712,39.259Z",
					transform: "translate(77.93 107.5)",
					fill: "#28666c"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group_243-2",
				"data-name": "Group 243",
				transform: "translate(8.01 7.765) rotate(90)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_190-4",
						"data-name": "Path 190",
						d: "M.155,3.014A3.782,3.782,0,0,0,1.748,1.623,7.618,7.618,0,0,0,2.459,0,2.516,2.516,0,0,0,.067,3.09.336.336,0,0,1,.155,3.014Z",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_191-4",
						"data-name": "Path 191",
						d: "M3.326.8A2.567,2.567,0,0,1,1.272,2.067,3.035,3.035,0,0,1,0,1.84a2.512,2.512,0,0,0,1.958.936A2.518,2.518,0,0,0,4.475.259,2.536,2.536,0,0,0,4.461,0C4.374,0,3.9.022,3.326.8Z",
						transform: "translate(0.56 2.258)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_192-4",
						"data-name": "Path 192",
						d: "M1.466,2.205C2.954,2.16,3.358,1,3.9.582a1.522,1.522,0,0,1,.9-.36C4.786.148,4.771.075,4.753,0a1.976,1.976,0,0,0-1.2.3,7.02,7.02,0,0,1-1.62,1.185A3.283,3.283,0,0,1,0,1.631a2.517,2.517,0,0,0,.157.307A3.147,3.147,0,0,0,1.466,2.205Z",
						transform: "translate(0.2 1.87)",
						fill: "#fff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_193-4",
						"data-name": "Path 193",
						d: "M0,3.13c.13.26,1.027-.024,1.413-.263.545-.339,1.107-1.084,1.752-1.26a2.748,2.748,0,0,1,.775-.1A2.518,2.518,0,0,0,1.8,0a7.848,7.848,0,0,1-.591,1.6C.694,2.676-.064,2.994,0,3.13Z",
						transform: "translate(0.883 0.005)",
						fill: "#fff"
					})
				]
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgAverageCycleDurationBackground);
export { ForwardRef as ReactComponent };
